import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ItemHdrQueryCriteriaClass, ItemHdrCriteriaModelQuery } from '../../../criteria/item-hdr-criteria.model';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Core2Config } from '../../shared/core2Config';
import { ApiVisa } from '../../shared/api-visa.model';
import { Observable } from 'rxjs';
import { FinancialItemLinkingContainerModel, FinancialItemLinkingQueryCriteria } from '../../../../../../models/aggregates/erp/financial-linking';
import { ItemMappingContainerModel } from '../../../../../../models/aggregates/item-mapping/item-mapping-container.model';
import { ItemLinkingContainerModel } from '../../../../../../models/aggregates/item-linking/item-linking-container.model';

@Injectable({
  providedIn: 'root'
})
export class ItemLinkingService extends BaseApiTemplateService<ItemLinkingContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = Core2Config.T2T_DOMAIN_URL_PREFIX + Core2Config.CONFIG_PREFIX + 'fi-item-linking/login-guest-ep';
    this.httpClient = http;
  }
  getItems(selfGuid, tenantHdr: ItemLinkingContainerModel, otherGuid, visa: ApiVisa): Observable<ApiResponseModel<ItemLinkingContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {

      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/' + selfGuid + '/' + tenantHdr + '/' + otherGuid;
    }
    return this.httpClient.get<ApiResponseModel<ItemLinkingContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }
}
